import { render } from "./PlayerMetricsWhitelist.vue?vue&type=template&id=b8815caa&scoped=true"
import script from "./PlayerMetricsWhitelist.vue?vue&type=script&lang=js"
export * from "./PlayerMetricsWhitelist.vue?vue&type=script&lang=js"

import "./PlayerMetricsWhitelist.vue?vue&type=style&index=0&id=b8815caa&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8815caa"]])

export default __exports__